<template>
  <b-modal
    :id="id"
    centered
    :hide-footer="true"
    :title="$t('Modify') + ' ' + $t('l.e') + ' ' + $t('chargePro')">
    <p>
      {{ $t('chargePro.edit.legend') }}
    </p>

    <div class="d-flex align-items-end justify-content-end mt-4">
      <b-button class="btn-sm mx-2" variant="outline-primary" @click="editOnlyOneCharge">
        {{ $t('chargePro.only.this') }}
      </b-button>
      <b-button class="btn-sm" variant="primary" @click="editAllFromChargeGroup">
        {{ $t('chargePro.chargeGroup') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>

export default {

  name: 'ProfessionalChargesEditModal',

  props: {
    selectedItem: Object
  },

  data() {
    return {
      id: "charge-edit-modal"
    }
  },

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    editOnlyOneCharge() {
      this.hideModal()
      this.$router.push({
        name: 'ProfessionalChargesCreateEdit',
        params: {
          chargeId: this.selectedItem.id,
          isChargeSimple: !this.selectedItem.isChargeGroup,
          isChargeGroup: false,
          chargeGroupId: null
        }
      })
    },

    editAllFromChargeGroup() {
      this.hideModal()
      this.$router.push({
        name: 'ProfessionalChargesCreateEdit',
        params: {
          chargeId: this.selectedItem.id,
          isChargeSimple: !this.selectedItem.isChargeGroup,
          isChargeGroup: true,
          chargeGroupId: this.selectedItem.chargeGroup
        }
      })
    },

    hideModal() {
      this.$bvModal.hide(this.id)
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/professionalCharges/components/ProfessionalChargesEditModal.vue